export default "__VITE_ASSET__DRichgfL__"